import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PayWay from "../BoatRegistration/Payments/PayWay";

const BuyerPayProcess = ({
  errPayWayFrame,
  errPayWayToken,
  tokenId,
  creditCard,
  createFrame,
  stateDestroy,
  resQueryPcCraft,
  appFee,
  setValue,
}) => {
  return (
    <>
      <div className="br-box">
        <div className="br-title">Payment</div>
        <p>
            The fee is a flat fee for all boats (not based on length or vessel value) – the fee applicable from {appFee?.t_dateFrom} is ${appFee?.t_fee?.toFixed(2)}.
        </p>
        <p>The transfer fee indicated is a once off fee.</p>
        <p>
            The fee is indexed each year and will go up essentially by CPI each July.
        </p>
        <p>
            If the vessel is expired but expired for less than 12 months, a registration fee applies in addition to the transfer fee.
        </p>
        <p>
          If you choose to pay online using a credit card, MAST only accepts
          <strong> Mastercard</strong> or <strong> Visa</strong>.
        </p>
        <ul className="tsf-fee-breakdown">
          <li>
            <span className="label">Transfer fee</span>
            <span className="amount">${appFee?.t_fee?.toFixed(2) ?? <FontAwesomeIcon icon={faQuestion} />}</span>
          </li>
          {appFee?.n_fee !== undefined && resQueryPcCraft?.is_expired_in_12_months === true && (
            <li>
              <span className="label">Registration fee ({appFee?.n_dateFrom} - {appFee?.n_dateTo})</span>
              <span className="amount">${appFee?.n_fee?.toFixed(2)}</span>
            </li>
          )}
          <div className="tsf-fee-total">
            <span>Amount payable</span>
            <span>{appFee?.t_fee && appFee?.n_fee !== undefined && resQueryPcCraft?.is_expired_in_12_months === true
                ? `$${(appFee.t_fee + appFee.n_fee).toFixed(2)}`
                : appFee?.t_fee
                ? `$${appFee.t_fee.toFixed(2)}`
                : <FontAwesomeIcon icon={faQuestion} />}
            </span>
          </div>
        </ul>
      </div>
      <PayWay
        errPayWayFrame={errPayWayFrame}
        errPayWayToken={errPayWayToken}
        tokenId={tokenId}
        creditCard={creditCard}
        createFrame={createFrame}
        stateDestroy={stateDestroy}
        setValue={setValue}
      />
    </>
  );
};

export default BuyerPayProcess;
